import { Mutator } from 'final-form'
import arrayMutators from 'final-form-arrays'
import { capitalize } from 'lodash'

const clearRootSubType: Mutator<any> = (_, state, { changeValue }) => {
  changeValue(state, 'root_subtype', () => '')
}

const titleCase: Mutator<any> = ([fieldName], state, { changeValue }) => {
  changeValue(
    state,
    fieldName,
    (value) => value && value.trim().split(/\s+/).map(capitalize).join(' ')
  )
}

const appendAmountAndDosage: Mutator<any> = ([name], state, { changeValue }) => {
  const currentState: any = { ...state.formState.values }
  const [amount, dosage] = [currentState.amount, currentState.dosage]
  changeValue(
    state,
    name,
    (value) =>
      value &&
      value
        .trim()
        .concat(amount ? ` [${amount}]` : '')
        .concat(dosage ? ` (${dosage})` : '')
  )
}

export const mutators: {
  [key: string]: Mutator<any>
} = {
  ...arrayMutators,
  clearRootSubType,
  titleCase,
  appendAmountAndDosage,
}
